// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__20JUH","title":"Info_title__2Ex3j","selects":"Info_selects__rIYg7","requiredAsterisk":"Info_requiredAsterisk__1XOER"};